import React from "react";
import "./Signature.css";

const Signature = (props) => {
  const { name, email, phone, position, selectedCompany } = props;

  const companyConfig = {
    vietcetera: {
      name: "Your name",
      email: "yourname@vietcetera.com",
      position: "Your position",
      phone: "+84 xxx.xxxx",
      logo: "https://img.vietcetera.com/uploads/images/logo-vietcetera/10YS_Vietcetera_Email_Signature_Animated.gif",
      logoStyle: { marginTop: "4px" },
      website: "https://vietcetera.com/en/about",
      address: {
        building: "Genesia Orbit Vietnam Building",
        street: "53 Nguyen Co Thach, An Khanh Ward, HCMC"
      },
      socialLinks: [
        {
          url: "https://vietcetera.com/",
          icon: "https://img.vietcetera.com/uploads/images/logo-vietcetera/logo-v-circle-black.jpg"
        },
        {
          url: "https://www.instagram.com/vietcetera/",
          icon: "https://img.vietcetera.com/uploads/images/signature_assets/ig.png"
        },
        {
          url: "https://www.facebook.com/vietcetera",
          icon: "https://img.vietcetera.com/uploads/images/signature_assets/fb.png"
        },
        {
          url: "https://www.linkedin.com/showcase/vietcetera-vn/",
          icon: "https://img.vietcetera.com/uploads/images/signature_assets/in.png"
        }
      ]
    },
    vnid: {
      name: "Your name",
      email: "yourname@vni-digest.com",
      position: "Your position",
      phone: "+84 xxx.xxxx",
      logo: "https://img.vietcetera.com/uploads/images/email-signature/vnid-logo-1.png",
      logoStyle: {},
      website: "https://vietcetera.com/",
      address: {
        building: "Genesia Orbit Vietnam Building",
        street: "53 Nguyen Co Thach, An Khanh Ward, HCMC"
      },
      socialLinks: [
        {
          url: "https://vietcetera.com/",
          icon: "https://img.vietcetera.com/uploads/images/logo-vietcetera/logo-v-circle-black.jpg"
        },
        {
          url: "https://www.youtube.com/@vietnaminnovatorsdigest/featured",
          icon: "https://img.vietcetera.com/uploads/images/signature_assets/youtube.png"
        },
        {
          url: "https://www.instagram.com/vietnam_innovators_digest/",
          icon: "https://img.vietcetera.com/uploads/images/signature_assets/ig.png"
        },
        {
          url: "https://www.facebook.com/vietnaminnovatorsdigest/",
          icon: "https://img.vietcetera.com/uploads/images/signature_assets/fb.png"
        },
        {
          url: "https://www.tiktok.com/@vietnaminnovatorsdigest",
          icon: "https://img.vietcetera.com/uploads/images/signature_assets/tiktok.png"
        },
        {
          url: "https://www.linkedin.com/showcase/vietnaminnovators/",
          icon: "https://img.vietcetera.com/uploads/images/signature_assets/in.png"
        }
      ],
      vnidSubscription: {
        title: "Stay informed, stay competitive — subscribe to",
        link: {
          label:"Vietnam Innovators Digest Newsletter.",
          href: "https://vietcetera.com/en/subscribe/vni-digest"
        }
      },
    }
  };

  const config = companyConfig[selectedCompany];

  const getLogoType = (url = "") => {
    const ext = url.split("?")[0].split("#")[0].split(".").pop().toLowerCase();
    return ["png", "jpg", "jpeg", "gif"].includes(ext) ? ext : "png";
  };

  const logoSizeByType = {
    gif: { width: 360, height: 108 },
    png: { width: 90, height: 36 },
    jpg: { width: 90, height: 36 },
    jpeg: { width: 90, height: 36 },
  };

  const logoType = getLogoType(config.logo);
  const logoSize = config.logoSize || logoSizeByType[logoType];

  const defaultValue = {
    name: config.name,
    email: config.email,
    position: config.position,
    phone: config.phone,
  };

  function selectElementContents(el) {
    var body = document.body,
      range,
      sel;
    if (document.createRange && window.getSelection) {
      range = document.createRange();
      sel = window.getSelection();
      sel.removeAllRanges();
      try {
        range.selectNodeContents(el);
        sel.addRange(range);
      } catch (e) {
        range.selectNode(el);
        sel.addRange(range);
      }
      document.execCommand("copy");
      alert("Copied successfully!");
    } else if (body.createTextRange) {
      range = body.createTextRange();
      range.moveToElementText(el);
      range.select();
      range.execCommand("Copy");
      alert("Copied successfully!");
    }
  }

  return (
    <div style={{ width: "100%" }}>
      <table id="myTable" width="100%" style={{ width: "640px" }}>
        <tbody>
          <tr>
            <td colSpan={2} style={{ height: "35px" }}></td>
          </tr>
          <tr>
            <td style={{ verticalAlign: "top" }}>
              <table cellPadding={0} cellSpacing={0}>
                <tbody>
                  <tr>
                    <td
                      style={{
                        fontWeight: 700,
                        fontSize: 18,
                        color: "#292929",
                        textTransform: "uppercase",
                      }}
                    >
                      {name ? name : defaultValue.name}
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        fontSize: 12,
                        color: "#292929",
                        textTransform: "uppercase",
                      }}
                    >
                      {position ? position : defaultValue.position}
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        paddingTop: "10px",
                        fontSize: 12,
                        textTransform: "uppercase",
                      }}
                    >
                      <a
                        style={{ color: "#292929", textDecoration: "none" }}
                        href={`mailto:${email}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {email ? email : defaultValue.email}
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        fontSize: 12,
                        textTransform: "uppercase",
                      }}
                    >
                      <a
                        style={{ color: "#292929", textDecoration: "none" }}
                        href={`tel:${phone}`}
                      >
                        {phone ? phone : defaultValue.phone}
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td align="right" style={{ verticalAlign: "middle", textAlign: "right" }}>
              <a
                href={config.website}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={config.logo}
                  style={config.logoStyle}
                  alt="company-logo"
                  width={logoSize.width}
                  height={logoSize.height}
                />
              </a>
            </td>
          </tr>
          <tr>
            <td
              colSpan={2}
              style={{
                paddingTop: "15px",
                fontSize: 0,
                lineHeight: 0,
                borderBottom: "1px solid #292929",
              }}
            ></td>
          </tr>
          <tr style={{ fontSize: 12, color: "#292929" }}>
            <td
              colSpan={2}
              style={{ paddingTop: "10px", paddingBottom: "10px" }}
            >
              <strong>{config.address.building}</strong>
              <br />
              {config.address.street}
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              {config.socialLinks.map((social, index) => (
                <a
                  key={index}
                  target="_blank"
                  rel="noopener noreferrer"
                  href={social.url}
                  style={{ marginRight: "12px" }}
                >
                  <img
                    width="30px"
                    src={social.icon}
                    alt={`logo-${selectedCompany}-${index}`}
                  />
                </a>
              ))}
            </td>
          </tr>

          {config?.vnidSubscription && (
            <tr style={{ fontSize: 12, color: "#292929" }}>
              <td colSpan={2} style={{ paddingTop: "10px" }}>
                <span>{config.vnidSubscription.title}</span><br />
                <a href={config.vnidSubscription.link.href} target="_blank">
                  {config.vnidSubscription.link.label}
                </a>
              </td>
            </tr>
          )}
        </tbody>
      </table>

      
      <button
        onClick={() =>
          selectElementContents(document.getElementById("myTable"))
        }
        style={{ display: "block", marginTop: "12px" }}
        className="btn"
      >
        Copy
      </button>
    </div>
  );
};

export default Signature;
